<template>
	<el-switch v-bind="$attrs" v-on="$listeners">
	  <slot></slot>
	</el-switch>
</template>
<script>
export default {
  name: "aia-switch",
};
</script>